// Форматування грошей (копія Shopify.formatMoney)
function formatMoney(cents, format) {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  function formatWithDelimiters(
    number,
    precision = 2,
    thousands = ",",
    decimal = "."
  ) {
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split(".");
    var dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    var cents = parts[1] ? decimal + parts[1] : "";
    return dollars + cents;
  }

  switch (format) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    default:
      value = formatWithDelimiters(cents, 2);
  }
  return value;
}

document.addEventListener("DOMContentLoaded", function () {
  const priceInButton = document.querySelector(
    ".product-form__price-in-button"
  );
  const addToCartButton = document.querySelector("[data-add-to-cart]");
  const variantDataElement = document.getElementById("custom-variant-data");

  if (!priceInButton || !addToCartButton || !variantDataElement) {
    console.log(
      "Не знайдено priceInButton, addToCartButton або custom-variant-data"
    );
    return;
  }

  const variants = JSON.parse(variantDataElement.innerHTML.trim());
  console.log("Variants:", variants); // Перевірка, що все ок

  // Слухаємо кліки на чіпах
  document
    .querySelectorAll("[data-option-buttons] button")
    .forEach((button) => {
      button.addEventListener("click", function () {
        console.log("Чіп клікнутий");

        // Збираємо вибрані опції
        const selectedOptions = [];
        document
          .querySelectorAll("[data-option-buttons]")
          .forEach((optionGroup) => {
            const selectedButton = optionGroup.querySelector("button.selected");
            if (selectedButton) {
              selectedOptions.push(
                selectedButton.getAttribute("data-option-value")
              );
            }
          });

        console.log("Вибрані опції:", selectedOptions);

        // Знаходимо відповідний варіант
        const matchedVariant = variants.find((variant) => {
          return variant.options.every(
            (opt, index) => opt === selectedOptions[index]
          );
        });

        console.log("Matched Variant:", matchedVariant);

        if (matchedVariant) {
          // Оновлюємо ціну в кнопці
          priceInButton.textContent = formatMoney(
            matchedVariant.price,
            "amount"
          );

          // Оновлюємо доступність кнопки
          if (matchedVariant.available) {
            addToCartButton.disabled = false;
            addToCartButton.setAttribute("aria-disabled", "false");
          } else {
            addToCartButton.disabled = true;
            addToCartButton.setAttribute("aria-disabled", "true");
          }
        }
      });
    });
});
